export function PushPermissionPrompt() {
  return null
}
